import { render, staticRenderFns } from "./NavCustom.vue?vue&type=template&id=2be3fbf6&scoped=true"
import script from "./NavCustom.vue?vue&type=script&lang=js"
export * from "./NavCustom.vue?vue&type=script&lang=js"
import style0 from "./NavCustom.vue?vue&type=style&index=0&id=2be3fbf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be3fbf6",
  null
  
)

export default component.exports